/**
 * Storeit: saubere Worttrennung für lange deutsche Kategorienamen.
 * Setzt unsichtbare Trennstellen (&shy;) an den Wortfugen, z. B.
 * "Aufbewahrungs|boxen", "Spielzeug|aufbewahrung". Der Browser trennt dann nur
 * dort, statt mitten im Wort ("Aufbewahrungsboxe / n", "Spielzeugaufbe-wahrung").
 * Neue Wörter: einfach unten in JOINTS ergänzen.
 */
(function () {
  var SHY = '­';
  var JOINTS = [
    [/(Aufbewahrungs)(box|korb|körb|tasche|system|lösung|regal|kiste)/gi],
    [/(Spielzeug)(aufbewahrung|kiste|box|korb)/gi],
    [/(Wäsche)(korb|körb|sammler|box|tasche)/gi],
    [/(Kleider)(ständer|schrank|stange)/gi],
    [/(Schuh)(regal|schrank|box|bank)/gi],
    [/(Unterbett)(kommode|box|tasche)/gi],
    [/(Klappdeckel)(box)/gi],
    [/(Geschenkpapier)(organizer|box)/gi],
    [/(Kinder)(zimmer|aufbewahrung)/gi],
    [/(Schlaf)(zimmer)/gi],
    [/(Wohn)(zimmer)/gi],
    [/(Home)(office)/gi],
    [/(Ordnungs)(system|helfer)/gi],
    [/(Kleiderschrank)(organizer|system)/gi],
    [/(Sitz)(bänke|bank|hocker)/gi]
  ];
  var SELECTOR = [
    '.storeit-card__name',
    '.menu-drawer__menu-item-text',
    '.mega-menu__link',
    '.storeit-category-grid__name',
    '.storeit-page-hero__title'
  ].join(',');

  function fix(el) {
    if (el.dataset.storeitShy) return;
    el.dataset.storeitShy = '1';
    var walker = document.createTreeWalker(el, NodeFilter.SHOW_TEXT);
    var node;
    while ((node = walker.nextNode())) {
      var t = node.nodeValue;
      if (t.length < 12 || t.indexOf(SHY) !== -1) continue;
      var out = t;
      for (var i = 0; i < JOINTS.length; i++) out = out.replace(JOINTS[i][0], '$1' + SHY + '$2');
      if (out !== t) node.nodeValue = out;
    }
  }

  function run(root) {
    (root || document).querySelectorAll(SELECTOR).forEach(fix);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { run(); });
  else run();

  // Filter, Sortierung und Warenkorb laden Inhalte nach: neue Karten mitnehmen.
  var pending = false;
  new MutationObserver(function () {
    if (pending) return;
    pending = true;
    requestAnimationFrame(function () { pending = false; run(); });
  }).observe(document.documentElement, { childList: true, subtree: true });
})();
